module.exports = __webpack_public_path__ + "img/bg6-1.9671300b.png";